import { type JobsSubscriptionStatus, useLocationsRetrieve } from "@sidegigllc/api/client";
import { useActiveLocationId } from "services/locationOrgContext";

/** The Jobs plan the server resolved for a location (the active one by default). Undefined while loading. */
export const useJobsSubscription = (locationId?: number): JobsSubscriptionStatus | undefined => {
  const [activeLocationId] = useActiveLocationId();
  const id = locationId ?? activeLocationId;
  const { data } = useLocationsRetrieve(id ?? -1, {
    query: {
      enabled: !!id,
      // A list-shaped row prefilled into this cache has no jobs_subscription: fetch the detail instead of waiting.
      refetchOnMount: (query) => (query.state.data?.jobs_subscription ? true : "always"),
    },
  });
  return data?.jobs_subscription;
};
